import React, { Suspense, lazy, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AppLayout from "../components/layouts/app-layout";
import LoaderModal from "../components/modals/loader-modal";
import PrivateRoute from "./privateRoute";
import ProtectedRoute from "./protectedRoute";
import Login from "../modules/auth/login";
import Dashboard from "../modules/dashboard/dashboard";
import Products from "../modules/products/product-list";
import Categories from "../modules/categories/category-list";
import Settings from "../modules/settings/settings";
import Inventory from "../modules/inventory/inventory";
import RoutesList from "../modules/routes/routes-list";
import Stores from "../modules/stores/store-list";
import Dropers from "../modules/dropers/droper-list";
import Orders from "../modules/orders/orders-list";
import Reports from "../modules/reports/reports";
import InventoryReport from "../modules/reports/inventory-report";
import StockInReport from "../modules/reports/stock-in-report";
import UnderDevelopment from "../components/underDevelopment";
import ProductSalesReport from "../modules/reports/product-wise-sales";
import { useDispatch } from "react-redux";
import { setFavicon } from "../components/helper";
import { viewSettingsAction } from "../redux/actions/settingsAction";
import { errorToast } from "../components/notifications/toast";
import Credits from "../modules/credits/credits-list";
import ViewCreditDetails from "../modules/credits/view-credit";

//Lazy loaders it will loads the componenet when its needed
const CreateProduct = lazy(() => import("../modules/products/create-product"));
const CreateOrEditCategory = lazy(() => import("../modules/categories/create-edit-category"));
const StockInflow = lazy(() => import("../modules/inventory/stock-inflow/stock-in-flow"));
const CreateRoute = lazy(() => import("../modules/routes/create-route"));
const ViewRouteDetails = lazy(() => import("../modules/routes/route-view"));
const StockReport = lazy(() => import("../modules/inventory/stock-report/stock-report"));
const StockReturn = lazy(() => import("../modules/inventory/stock-return/stock-return"));
const CreateEditStore = lazy(() => import("../modules/stores/create-edit-store"));
const CreateEditDroper = lazy(() => import("../modules/dropers/create-edit-droper"));
const ViewDroperDetails = lazy(() => import("../modules/dropers/droper-view"));
const CreateOrder = lazy(() => import("../modules/orders/create-edit-order"));
const ViewStoreDetails = lazy(() => import("../modules/stores/store-view"));

function MainRoute() {
    const dispatch = useDispatch();
    const token = localStorage.getItem("accessToken")
    useEffect(() => {
        if (token) {
            fetchDetails()
        }
    }, [token])


    const fetchDetails = async () => {
        dispatch(viewSettingsAction({}, onSuccess, onError))
    };

    const onSuccess = (data) => {
        if (data.data.data.company.logo) {
            setFavicon(data.data.data?.company?.logo);
            document.title = `${data.data.data?.company?.name} - Invetix`
        }
    }
    const onError = (data) => {
        const errorMsg = data.data.message || "Unable to fetch try later";
        errorToast(errorMsg)
    }

    return (
        <Router>
            <Suspense fallback={<div><LoaderModal /></div>}>
                <Routes>
                    <Route element={<ProtectedRoute />}>
                        <Route path="/" element={<Login />} />
                    </Route>
                    <Route element={<PrivateRoute />}>
                        <Route element={<AppLayout />}>
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="/products" element={<Products />} />
                            <Route path="/products/create-product" element={<CreateProduct />} />
                            <Route path="/products/edit-product/:id" element={<CreateProduct />} />
                            <Route path="/categories" element={<Categories />} />
                            <Route path="/categories/create-category" element={<CreateOrEditCategory />} />
                            <Route path="/categories/edit-category/:id" element={<CreateOrEditCategory />} />
                            <Route path="/settings" element={<Settings />} />
                            <Route path="/inventory" element={<Inventory />} />
                            <Route path="/inventory/stock-inflow" element={<StockInflow />} />
                            <Route path="/inventory/stock-return" element={<StockReturn />} />
                            <Route path="/inventory/stock-report" element={<StockReport />} />

                            <Route path="/routes" element={<RoutesList />} />
                            <Route path="/routes/create" element={<CreateRoute />} />
                            <Route path="/routes/view/:id" element={<ViewRouteDetails />} />
                            <Route path="/routes/edit/:id" element={<CreateRoute />} />

                            <Route path="/stores" element={<Stores />} />
                            <Route path="/stores/create" element={<CreateEditStore />} />
                            <Route path="/stores/edit/:id" element={<CreateEditStore />} />
                            <Route path="/stores/view/:id" element={<ViewStoreDetails />} />

                            <Route path="/dropers" element={<Dropers />} />
                            <Route path="/dropers/create" element={<CreateEditDroper />} />
                            <Route path="/dropers/edit/:id" element={<CreateEditDroper />} />
                            <Route path="/dropers/view/:id" element={<ViewDroperDetails />} />

                            <Route path="/orders" element={<Orders />} />
                            <Route path="/orders/create" element={<CreateOrder />} />
                            <Route path="/orders/edit/:id" element={<CreateOrder />} />
                            <Route path="/orders/view/:id" element={<CreateOrder />} />

                            <Route path="/reports" element={<Reports />} />
                            <Route path="/reports/inventory" element={<InventoryReport />} />
                            <Route path="/reports/stock-in" element={<StockInReport />} />
                            <Route path="/reports/product-sales" element={<ProductSalesReport />} />

                            <Route path="/credits" element={<Credits />} />
                            <Route path="/credits/view/:id" element={<ViewCreditDetails />} />

                            <Route path="/under-dev" element={<UnderDevelopment />} />

                        </Route>
                    </Route>
                </Routes>
                <ToastContainer limit={2} />
            </Suspense>
        </Router >
    );
}

export default MainRoute;
